module.exports = __webpack_public_path__ + "assets/ic_examine.c3061dbc.svg";